import "./secondary-nav-current";
import "./secondary-nav-item";
import "./secondary-nav-group";
import { html, unsafeCSS } from "lit";
import { customElement, property } from "lit/decorators.js";
import type { SecondaryNavCompactToggleEvent } from "@/components/shell/shell";
import { EkoElement } from "@/utilities/element";
import style from "./secondary-nav.css?inline";

@customElement("eko-secondary-nav")
class Navigation extends EkoElement {
  static styles = [...EkoElement.styles, unsafeCSS(style)];

  @property({ reflect: true, type: Boolean }) compact: boolean = false;

  setCompact = (event: SecondaryNavCompactToggleEvent) => {
    this.compact = event.detail.compact;
  };

  connectedCallback(): void {
    super.connectedCallback();

    document.addEventListener("secondary-nav:compact:toggle", this.setCompact);
  }

  disconnectedCallback(): void {
    super.disconnectedCallback();

    document.removeEventListener("secondary-nav:compact:toggle", this.setCompact);
  }

  render() {
    return html`<nav class="eko-secondary-nav">
      <div class="eko-secondary-nav__current">
        <slot name="current"></slot>
      </div>
      <div class="eko-secondary-nav__list">
        <slot></slot>
      </div>
    </nav>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "eko-secondary-nav": Navigation;
  }
}

export default Navigation;
